var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "movie_nav_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置分类及排序 "),
        _c("span", { staticClass: "tips" }, [_vm._v("（拖动分类可调整排序）")]),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "is-no-asterisk",
          attrs: {
            prop: "category_id",
            label: "选择菜单",
            rules: [{ required: true, message: "请选择菜单" }],
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                clearable: "",
                filterable: "",
                placeholder: "请选择电影类型菜单",
              },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (menu) {
              return _c("el-option", {
                key: menu.id,
                attrs: { label: menu.show_name, value: menu.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: item.id, class: ["box", !item.status && "disabled"] },
            [
              _c(
                "div",
                { staticClass: "list" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm._f("typeFilter")(item.type))),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { margin: "0" },
                      attrs: { prop: "value." + index + ".status" },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-value": true,
                          "inactive-value": false,
                        },
                        on: { change: _vm.changeSwitch },
                        model: {
                          value: item.status,
                          callback: function ($$v) {
                            _vm.$set(item, "status", $$v)
                          },
                          expression: "item.status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "list" },
                [
                  _c("div", { staticClass: "label nickName" }, [
                    _vm._v(" 分类名称 "),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".name",
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              return _vm.checkList(
                                rule,
                                value,
                                callback,
                                item.status
                              )
                            },
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          disabled: !item.status,
                          placeholder: "输入5个字以内的名称",
                        },
                        model: {
                          value: item.name,
                          callback: function ($$v) {
                            _vm.$set(item, "name", $$v)
                          },
                          expression: "item.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }